<template>
    <div id="cofiscart" class="row cc-theme--globalmoto">
        <div class="cc-theme--globalmoto__alerts" v-if="isCartEmpty">
            <div class="cc-alert cc-alert--error cc-alert--with-background">{{ translations['Your shopping cart is empty'] }}</div>
        </div>
        <div class="cc-theme--globalmoto__products-and-accessories" v-if="!isCartEmpty">
            <div class="cc-theme--globalmoto__products">
                <products/>
            </div>
            <div class="cc-theme--globalmoto__accessories">
                <accessories/>
            </div>
        </div>
        <div class="cc-theme--globalmoto__addresses-and-delivery" v-if="!isCartEmpty">
            <div class="cc-theme--globalmoto__addresses">
                <addresses/>
            </div>
            <div class="cc-theme--globalmoto__carriers">
                <carriers/>
            </div>
            <div class="cc-theme--globalmoto__payments">
                <payments/>
            </div>
            <div class="cc-theme--globalmoto__consents">
                <consents/>
            </div>
            <div class="cc-theme--globalmoto__finish-order">
                <button class="cc-button cc-button--finish-order" @click="finishOrder">{{ translations['Finish order'] }}</button>
                <div id="paymentshooks" style="visibility: hidden; position: absolute" v-html="paymentHooks"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    import Products from "./Products";
    import Accessories from "./Accessories";
    import Addresses from "./Addresses";
    import Carriers from "./Carriers";
    import Payments from "./Payments";
    import Consents from "./Consents";

    export default {
        components: {
            Products,
            Accessories,
            Addresses,
            Carriers,
            Payments,
            Consents,
        },
        computed: {
            ...mapState({
                translations: state => state.translations,
                products: state => state.products,
                selectedCarrier: state => state.selectedCarrier,
                selectedPayment: state => state.selectedPayment,
                currentPayment: state => state.currentPayment,
                carriersPaymentsMap: state => state.carriersPaymentsMap,
                paymentHooks: state => state.paymentHooks,
            }),
            isCartEmpty: function () {
                return !(this.products && this.products.length > 0);
            },
        },
        methods: {
            finishOrder: function () {
                this.showLoading();

                this.$store.commit('SET_CONSENT_TERMS_OF_SERVICE', true);
                this.$store.commit('SET_CONSENT_PRIVACY_POLICY', true);

                return this.$store.dispatch('FINISH_ORDER')
                    .then((data) => {
                        if (this.$store.getters.hasUserError) {
                            const erroneousInput = document.querySelector('.cc-invalid');

                            erroneousInput.parentNode.scrollIntoView({
                                behavior: "smooth",
                                block: "start",
                            });

                            this.hideLoading();

                            return;
                        }

                        if (!this.selectedCarrier) {
                            document.querySelectorAll('.cc-carrier').forEach(item => {
                                item.classList.add('cc-invalid')
                            });

                            document.querySelector('.cc-theme--globalmoto__carriers').scrollIntoView({
                                behavior: "smooth",
                                block: "start",
                            });

                            this.hideLoading();

                            return;
                        } else {
                            document.querySelectorAll('.cc-carrier').forEach(item => {
                                item.classList.remove('cc-invalid')
                            });
                        }

                        if (!this.selectedPayment) {
                            document.querySelectorAll('.cc-payment').forEach(item => {
                                item.classList.add('cc-invalid')
                            });

                            document.querySelector('.cc-theme--globalmoto__payments').scrollIntoView({
                                behavior: "smooth",
                                block: "start",
                            });

                            this.hideLoading();

                            return;
                        } else {
                            document.querySelectorAll('.cc-payment').forEach(item => {
                                item.classList.remove('cc-invalid')
                            });
                        }

                        const carriersPaymentsMapElement = this.carriersPaymentsMap[this.selectedCarrier];

                        if (!carriersPaymentsMapElement) {
                            alert(this.translations['Invalid carrier/payment combination']);
                            this.hideLoading();
                            return;
                        }

                        const selectedPayment = carriersPaymentsMapElement.filter(item => {
                            return this.currentPayment.name === item.payment;
                        });

                        if (selectedPayment.length < 1) {
                            alert(this.translations['Invalid carrier/payment combination']);
                            this.hideLoading();
                        }

                        if (data.status === 'error') {
                            alert(data.message);

                            if (typeof data.reason !== 'undefined') {
                                if (data.reason === 'carrier_mismatch') {
                                    this.$store.dispatch('SELECT_CARRIER', null);
                                    this.$store.dispatch('SELECT_PAYMENT', null);
                                }
                            }

                            this.hideLoading();
                        }
                    });
            },
            showLoading: function () {
                const body = document.getElementsByTagName('body')[0];
                const coverSpin = document.createElement('div');
                coverSpin.id = 'cart-cover-spin';
                body.appendChild(coverSpin);
            },
            hideLoading: function () {
                document.getElementById('cart-cover-spin').remove();
            },
        },
        name: 'Globalmoto',
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/components/theme";
</style>
